import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Flame } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/cuenta", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/cuenta", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/cuenta", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Flame className="animate-pulse text-habanero" size={40} />
    </div>
  );
}
